/**
 * Placeholder 3D isometric cube logo.
 * Drop in a real Celebal logo SVG here later — keep the export name `CubeLogo`
 * and the same {size, className} prop shape and everywhere else just works.
 */
export default function CubeLogo({ size = 32, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="CORE"
      role="img"
    >
      {/* Top face — accent red */}
      <path
        d="M32 8 L56 20 L32 32 L8 20 Z"
        fill="#d76d62"
      />
      {/* Left face — dark warm */}
      <path
        d="M8 20 L32 32 L32 58 L8 46 Z"
        fill="#1a1410"
      />
      {/* Right face — slightly lighter dark */}
      <path
        d="M56 20 L32 32 L32 58 L56 46 Z"
        fill="#3a352e"
      />
      {/* Top face inner highlight */}
      <path
        d="M32 8 L56 20 L32 32 L8 20 Z"
        fill="url(#topShine)"
        fillOpacity="0.6"
      />
      <defs>
        <linearGradient id="topShine" x1="32" y1="8" x2="32" y2="32" gradientUnits="userSpaceOnUse">
          <stop stopColor="#e88478" />
          <stop offset="1" stopColor="#c8453a" />
        </linearGradient>
      </defs>
    </svg>
  );
}
